import React from "react";

type UserInfoProps = {
  label: string;
  value?: number;
};

export const UserInfo: React.FC<UserInfoProps> = ({ label, value }) => {
  return (
    <div className="flex flex-col px-3 py-1 text-white rounded shadow-lg bg-sky-600">
      <span className="text-sm font-semibold">{label}</span>
      <span className="text-xs">{value}</span>
    </div>
  );
};
